import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import LineBreakBrText from "../../../../../../common/LineBreakBrText";

const CommentBody = ({data}) => {
  const [showShowMoreButton, setShowShowMoreButton] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [shortContent, setShortContent] = useState();

  const container = useRef()

  const content = data.content;

  /** Determine where to cut a long comment.
   * Uses a score instead of content length in case there's a comment that's just 500 line breaks. */
  const calculateContentLengthScore = () => {
    /** The threshold is the cutting point, but not the max length.
     * This is to avoid situations where the shortened content is barely shorter than the max length.
     */
    const THRESHOLD = 500;
    const MAX_SCORE_BEFORE_CUT = 700;
    const LINE_BREAK_SCORE = 100;
    let score = 0;
    let lastNotLineBreak = 0;
    let cutAt = 0
    for(let i = 0; i < content.length; i++) {
      if (content[i]==='\n') {
        score+=LINE_BREAK_SCORE;
      } else {
        lastNotLineBreak = i;
        score++;
      }
      if (!cutAt && score >= THRESHOLD) {
        cutAt = lastNotLineBreak+1;
      }
      if (score >= MAX_SCORE_BEFORE_CUT) {
        setShortContent(content.substring(0,cutAt)+"...");
        setShowShowMoreButton(true);
        setShowMore(false);
        return i;
      }
    }
    setShowShowMoreButton(false);
    setShowMore(false);
  }

  useEffect(() => {
    setTimeout(() => {
      // Changing the showMore sets the focus on the text
      // - for scrolling, and 
      // - to not reset the keyboard focus when elements get rerendered
      container.current.scroll(0,0)
      container.current.focus();
    }, 0)
  }, [showMore])

  useEffect(() => {
    calculateContentLengthScore();
  }, [content])

  const commentParagraphClass = (data) => {
    const contentChars = [...data.content];
    if (contentChars.length < 4) {
      const allEmojis = contentChars.reduce(
        (prev, char) => (prev && /\p{Emoji}/u.test(char)), true,
      );
      if (allEmojis) {
        return 'emoji-comment';
      }
    }
    return '';
  };

  const handleShowMore = () => {
    setShowMore(true);
    setShowShowMoreButton(false);
    container.current.focus()
  }
  const handleShowLess = () => {
    container.current.scroll(0,0);
    setShowMore(false);
    setShowShowMoreButton(true);
  }

  return (
  <div className="hearing-comment-body">
    <div className={classNames([{
        "hearing-comment-body-short" : !showMore,
        "hearing-comment-body-show-more": showShowMoreButton,
        "hearing-comment-body-long": showMore,
      }])}
      ref={container}
    >
      <p className={commentParagraphClass(data)}>
        <LineBreakBrText text={showShowMoreButton ? shortContent : data.content} />
      
      </p>
    </div>
    {showShowMoreButton && 
      <div aria-hidden="true">
        <button type="button" 
          onClick={handleShowMore}
          className="hearing-comment__toggle-full-content-button"
          >... <FormattedMessage id="showMore" /></button>
      </div>
    }
    {showMore &&
      <div aria-hidden="true">
        <button type="button" 
          onClick={handleShowLess}
          className="hearing-comment__toggle-full-content-button"
          ><FormattedMessage id="showLess" /></button>
      </div>
    }
  </div>)
}

export default CommentBody;